import {doc} from '../docs.js';
import {lazy} from 'utils/lazy.js';

doc(
    "concat",
    {
    },
    "Concatenates the list arguments together",
    undefined,
    {
        tags: "List",
        inlets: x => x,
        isHot: true
    }
);


export const concat = (zobject, ...args) => {
    let stored = [];
    return (msg) => {
        if (msg[0] === 'bang') {
            return stored;
        }
        let _args = args.map(arg => arg()).filter(arg => arg !== undefined).flatMap(arg => arg);
        let _msg = msg[0] || [];
        if (!Array.isArray(_msg)) {
            _msg = [_msg];
        }
        stored = [[..._msg, ... _args]];
        return stored;
    };
};

doc(
    "lconcat",
    {
    },
    "Concatenates the list arguments together (lazily)",
    undefined,
    {
        tags: "List",
        inlets: x => x,
    }
);


export const lconcat = (zobject, ...args) => {
    let stored = [];
    return (msg) => {
        if (msg[0] === 'bang') {
            return stored;
        }
        let _args = args.map(arg => arg()).filter(arg => arg !== undefined).flatMap(arg => arg);
        let _msg = msg[0] || [];
        if (!Array.isArray(_msg)) {
            _msg = [_msg];
        }
        stored = [[..._msg, ... _args]];
        return stored;
    };
};

doc(
    "list.prependIndex",
    {
    },
    "Prepends index at every element of inputted list"
);
export const prependIndex = (zobject) => {
    return ([msg]) => {
        let l = [];
        for (let i=0; i < msg.length; i++) {
            if (Array.isArray(msg[i])) {
                l.push([i, ... msg[i]]);
            }
        }
        return [l];
    };
};

doc(
    "list.appendEvery",
    {
        "toAppend":""
    },
    "Prepends index at every element of inputted list",
    () => 1,
    {
        inlets: 2
    });
export const appendEvery = (zobject, append) => {
    return ([msg]) => {
        let l = [];
        let _append = append();
        for (let i=0; i < msg.length; i++) {
            if (Array.isArray(msg[i])) {
                if (Array.isArray(_append)) {
                    l.push([...msg[i], _append[i]]);
                } else {
                    l.push([...msg[i], _append]);
                }
            }
        }
        return [l];
    };
};

doc(
    "listMax",
    {
    },
    "returns max number of list",
    () => 1,
    {
        inlets: 1,
        tags: "List"
    });
    
export const listMax = (zobject) => {
    return ([list]) => {
        return [Math.max(... list)];
    }
};

doc(
    "push",
    {
        length: "arg"
    },
    "Pushes msgs to beginning of list until length limit is met (First-in-first-out)",
    undefined,
    {
        tags: "List",
    }
);


export const push = (zobject, limit) => {
    let stored = [];
    return (msg) => {
        stored.unshift(msg[0]);

        if (stored.length > limit()) {
            stored.pop();
        }
        return [stored];
    };
};

doc(
    "append",
    {
        length: "arg"
    },
    "Pushes msgs into list until limit (bang sends its stored list if needed)",
    undefined,
    {
        inlets: 2,
        tags: "List",
    }
);


export const append = (zobject, limit) => {
    let stored = [];
    return (msg) => {
        if (msg[0] === 'bang') {
            return [stored];
        }
        stored.push(msg[0]);

        while (stored.length > limit()) {
            stored.shift();
        }
        return [stored];
    };
};

doc(
    "appendList",
    {
        "list to append": "",
        "limit": ""
    },
    "Pushes msgs into list until limit",
    undefined,
    {
        inlets: 2,
        tags: "List",
    }
);


export const appendList = (zobject, limit) => {
    let stored = [];
    return (msg) => {
        if (!Array.isArray(msg[0])) {
            msg[0] = [msg[0]];
        }
        for (let _msg of msg[0]) {
            stored.push(_msg);
        }

        while (stored.length > limit()) {
            stored.shift();
        }
        return [stored];
    };
};


doc(
    "nth",
    {
        n: "n"
    },
    "Get nth element from list",
    undefined,
    {
        inlets: 2,
        tags: "List",
        isHot: true
    }
);


export const nth = (zobject, n) => {
    return (msg) => {
        return msg[0][n() % msg[0].length];
    };
};


doc(
    "map",
    {
        "fn": ""
    },
    "Applies function to each element of list",
    undefined,
    {
        tags: "List",
        inlets: ["list", "fn"]
    }
);


export const map = (zobject, fn) => {
    let storedArray;
    return ([type, arg]) => {
        if (!arg || (!Array.isArray(arg) && !ArrayBuffer.isView(arg))) {
            return;
        }

        // find the object inn that innlet
        let inlet = zobject.inlets["fn"];
        if (!inlet) {
            return;
        }
        let {connections} = inlet;
        let connection = connections[0]
        let {sourceNode} = connection;

        if (ArrayBuffer.isView(arg)) {
            if (!storedArray) {
                storedArray = new Float32Array(arg.length);
            }
            for (let i=0; i < arg.length; i++) {
                let x = arg[i];
                let value = sourceNode.evaluateAsFunction ? 
                    sourceNode.evaluateAsFunction(x, i) : 
                    sourceNode.function([x]);
                storedArray[i] = value;
            }
        } else  {
            storedArray = arg.map(
                (x, i) => {
                    if (sourceNode.evaluateAsFunction) {
                        return sourceNode.evaluateAsFunction(x, i);
                    } else {
                        return sourceNode.function([x]);
                    }
                });
        }
        return [storedArray];
    };
};






doc(
    "interleaf",
    {
        value: "",
        position: ""
    },
    "Interleaves a number every x many positions",
    undefined,
    {
        tags: "List",
        inlets: 3
    }
);


export const interleaf = (zobject, value, position) => {
    let storedArray;
    return ([list]) => {
        let _value = lazy(value) || 0;
        let _position = lazy(position) || 2;

        if (ArrayBuffer.isView(list)) {
            if (list.length === 0) {
                return list;
            }
            storedArray = interleafTyped(list, _value, _position, storedArray);
            return [storedArray];
        }

        if (!Array.isArray(list) ) {
            return;
        }


        let interleaved = [];
        for (let i=0 ; i < list.length; i++) {
            if (i > 0 && i % _position === 0) {
                interleaved.push(_value);
            }
            interleaved.push(list[i]);
        }
        if (list.length % _position === 0) {
            interleaved.push(_value);
        }
        return [interleaved];
    };
}
 

const interleafTyped = (arr, value, position, storedArray) => {
    let newSize = arr.length + Math.floor(arr.length / position);
    let interleaved = storedArray && newSize.lengthh === storedArray.length ?
        storedArray : new Float32Array(newSize);
    let counter = 0;
    for (let i=0 ; i < arr.length; i++) {
        if (i > 0 && i % position === 0) {
            interleaved[counter++] = value;
        }
        interleaved[counter++] = arr[i];
    }
    if (arr.length % position === 0) {
        interleaved[interleaved.length - 1] = value;
    }
    return interleaved;
};

doc(
    "list",
    {
    },
    "Creates a list out of the inputed message (if possible",
    undefined,
    {
        tags: "List"
    }
);

export const list = () => {
    return ([arr]) => {
        return [Array.from(arr)];
    };
};

doc(
    "sublist",
    {
    },
    "Creates a list out of the inputed message (if possible",
    undefined,
    {
        tags: "List"
    }
);

export const sublist = (object, from, to) => {
    return ([arr]) => {
        if (Array.isArray(arr)) {
            return [arr.slice(from(), to())];
        }
    };
};

doc(
    "smokeVertices",
    {
        "size":""
    },
    "Yo",
    undefined,
    {
        inlets: 3,
    }
);

export const smokeVertices = (object, width, height) => {
    let cached;
    return ([densities]) => {
        // size = 400 px length = 24 we need to then 
        let _width = width() || 300;
        let _height = width() || 300;
        if (cached) {
            return cached;
        }
        cached = new Float32Array(new Array(densities.length).fill(0).flatMap(
            (density, pt) => {
                let x = pt%66;
                let y = (pt-x)/66;
                return [
                    _width*(x/64),
                    _height*(y/64),
                    0
                ];
            }));
        return cached;
    };
};

doc(
    "smokeColors",
    {
        "size":""
    },
    "Yo"
);

export const smokeColors = (object) => {
    let array;
    return ([densities]) => {
        // size = 400 px length = 24 we need to then 
        if (!array) {
            array = new Float32Array(densities.length * 3);
        }

        for (let i=0; i < densities.length; i++) {
            let d = Math.min(1, densities[i]*10);
            array[3*i] = d;
            array[3*i+1] = d;
            array[3*i+2] = d;
        }
        return [array];
    };
};



doc(
    "flattenList",
    {
    },
    "Flattens a list of lists",
    undefined,
    {
        tags: "List"
    }
);

export const flattenList = (object) => {
    return ([list]) => {
        if (Array.isArray(list)) {
            return [list.flat(16)];
        }
    };
};


doc(
    "cList",
    {
        "itemSize": ""
    },
    "Turns a list into  [0,1,2,3]",
);

export const cList = (object, itemSize) => {
    return ([list]) => {
        let l = [];
        for (let i=0; i < list.length; i += itemSize()) {
            l.push(i / itemSize());
        }
        return [Float32Array.from(l)];
    }
};

doc(
    "list.partition",
    {
        list: "",
        size: ""
    },
    "Partitions 1d list into groups based on size",
    undefined,
    {
        inlets: 2
    });

export const partition = (object, size) => {
    return ([list]) => {
        let part = [];
        let parts = [];
        for (let i=0; i < list.length; i++) {
            if (parts.length > 0 && i % size() === 0) {
                parts.push(part);
            } 
            part.push(list[i]);
        }
        return [parts];
    };
};

doc(
    "list.reverse",
    {
        list: "",
    },
    "Reverse a list and outputs the reversed list out of outlet");

export const reverseList = (object) => {
    return ([list]) => {
        list = [... list];
        list.reverse();
        return [list];
    };
};



doc(
    "list.indexOf",
    {
    },
    "Indexof in list",
    () => 1,
    {
        tags: "List",
        inlets: 2,
        isHot: true
    }
);

export const list_indexOf = (zobject, element) => {
    let stored = [];
    return ([list]) => {
        if (!Array.isArray(list)) {
            return -1;
        }
        let el = element();
        return list.indexOf(el);
    };
};

doc(
    "fillArray",
    {
        "val": "",
        "start": "",
        "end": "",
        "length": "",
    },
    "Fills a new array of given length from start to end with value",
    () => 1,
    {
        inlets: 4
    });
export const fillArray = (object, start, end, length) => {
    return ([val]) => {
        let arr = new Array(length()).fill(0);
        for (let i=start(); i < end(); i++) {
            arr[i] = val;
        }
        return [arr];
    };
};


doc(
    "interleavedConcat",
    {
        "lists":"",
    },
    "Intereaves a list of lists"
);
export const interleavedConcat = () => {
    let final = [];
    return ([lists]) => {
        if (!Array.isArray(lists)) {
            return [];
        }
        final.length = 0;
        for (let i=0; i < lists[0].length; i++) {
            for (let list of lists) {
                final.push(list[i]);
            }
        }
        return [final];
    };
};

doc(
    "centerFillArray",
    {
        "val": "",
        "length": "",
    },
    "Fills a new array of given length from start to end with value",
    () => 1,
    {
        inlets: 2
    });
export const centerFillArray = (object, length) => {
    return ([val]) => {
        let arr = new Array(length()).fill(0);
        let ab = Math.floor(Math.abs(val) * length() / 2);
        let c = 0;
        if (val < 0) {
            for (let i=length()/2; i > length()/2 - ab; i--) {
                arr[i] = (c++)/ab*100;
            }
        } else {
            for (let i=length()/2; i < length()/2 + ab; i++) {
                arr[i] = (c++)/ab*100;
            }
        }
        return arr;
    };
};


doc(
    "listOsc",
    {
        "list of osc": "",
    },
    "Returns a list for an oscilloscope ready to be thrown into a texture",
    () => 1,
    {
        inlets: 1
    });

export const listOsc = (o) => {
    let arr = undefined;
    let empty = undefined;
    let lastList = undefined;
    return ([list]) => {
        if (!list || (!Array.isArray(list) && !ArrayBuffer.isView(list))) {
            return;
        }
        if (!arr || Math.pow(list.length, 2) !== arr.length) {
            arr = new Uint8Array(Math.pow(list.length, 2));
            empty = new Uint8Array(Math.pow(list.length, 2));
        }


        if (lastList) {
            arr.set(empty);
        }

        let length = list.length;
        for (let i=0; i < list.length; i++) {
            let val = list[i];
            let ab = Math.floor(Math.abs(val) * length / 2);
            let c = 25;
            if (val < 0) {
                for (let j=length/2; j > length/2 - ab; j--) {
                    arr[j*length + i] = 100;// ((c++)/ab*125);
                }
            } else {
                for (let j=length/2; j < length/2 + ab; j++) {
                    arr[j*length + i] = 100; //((c++)/ab*125);
                }
            }
        }
        lastList = list;
        return arr;
    };
};


doc(
    "sparseList",
    {
        "List of indices": "",
        "Length of outputed list": "",
        "Value to place in each slot": "",
        "Chunk Size": "",
        "Chunk Offset": "",
        "Inputed Array": "",
    },
    "Returns a list of given length w elements placed at indices of inputed list",
    () => 1,
    {
        //isHot: true,
        inlets: 6
    });
export const sparseList = (o, len, values, chunkSize, chunkOffsets, inputArray) => {
    return ([msg]) => {
        let _values = values() || 100;
        if (!Array.isArray(_values)) {
            _values = [_values];
        }
        let _chunkSize = chunkSize() || 1;
        let _chunkOffsets = chunkOffsets() || [0];
        let _len = Math.round(len() * _chunkSize);
        if  (isNaN(_len)) {
            return;
        }

        let _inputArray = inputArray() ? [... inputArray()] : undefined;
        let arr = _inputArray || new Array(_len).fill(0);
        for (let x of msg) {
            let i=0;
            for (let _chunkOffset of _chunkOffsets) {
                arr[parseInt(x) * _chunkSize + _chunkOffset] = _values[i%_values.length];
                i++;
            }
        }
        return [arr];
    };
};

doc(
    "singleSparseList",
    {
        "List of indices": "",
        "Length of outputed list": "",
        "Value to place in each slot": "",
        "Chunk Size": "",
        "Chunk Offset": "",
        "Inputed Array": "",
    },
    "Returns a list of given length w elements placed at indices of inputed list",
    () => 1,
    {
        //isHot: true,
        inlets: 5
    });
export const singleSparseList = (o, len, value, chunkSize, chunkOffset) => {
    return ([msg]) => {
        let _chunkSize = chunkSize() || 1;
        let _chunkOffsets = chunkOffset() || [0];
        if (!Array.isArray(_chunkOffsets)) {
            _chunkOffsets = [_chunkOffsets];
        }
        let _len = Math.round(len() * _chunkSize);
        if  (isNaN(_len)) {
            return;
        }

        let arr = new Array(_len).fill(0);
        for (let x of msg) {
            for (let _chunkOffset of _chunkOffsets) {
                arr[parseInt(x) * _chunkSize + _chunkOffset] = value();
            }
        }
        return [arr];
    };
};

doc(
    "sparseMerge",
    {
    },
    "Merges lists together into one list ",
    undefined,
    {
        tags: "List",
        inlets: x => x,
        isHot: true
    }
);
export const sparseMerge = (object, ...args) => {
    return ([msg]) => {
        let _args = args.map(arg => arg()).filter(arg => arg !== undefined);
        let _msg = msg || [];

        let ret = [];
        let lists = [_msg, ... _args];
        for (let arg of lists) {
            for (let i=0; i < arg.length; i++) {
                if (arg[i]) {
                    ret[i] = arg[i];
                }
            }
        }
        return [ret];
    };
};

